<template>
<!-- Modal -->
<div class="modal fade" id="mdAttachView" tabindex="-1" aria-labelledby="mdAttachViewLabel" aria-hidden="true">
   <div class="modal-dialog modal-fullscreen">
      <div class="modal-content bg-transp">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
         pepe
        <button class="btn btn-primary" data-bs-target="#mdContent" data-bs-toggle="modal">Back to first</button>
      </div>
   </div>
   <!--
   -->
</div>
</template>

<style scoped>
.bg-transp {
   background-color: transparent;
   color: white;
}
.btn-close {
   color: white;
}
</style>
